<!-- 组件3   3图 -->
<template>
     <div class="ThemeOne" @click="jumpUrl(ItemDate.componentForwardType)">
         <img :src="ItemDate.pictureAndLinkVOS[0].pic" alt="">
    </div>
</template>
<script>
 import {
    GetCoupon
  } from '../../api/topicPage.js'
  import {Toast} from "vant";
  export default {
    name: "ThemeOne",
       inject:['reload'],
    data() {
      return {
        access_token:''
      }
    },
    components: {
    [Toast.name]: Toast,
  },
    props: {
        // 滚动数组
        ItemDate: {
            type: Object
        },
         token: {
            type: String
        },
    },
    created() {
       console.log('ThemeOne',this.ItemDate)
      //  alert(this.access_token)
    },
    methods: {
       // 手动领取优惠券
    getCouponFun(access_token,couponId) {
      GetCoupon(access_token,couponId).then((data) => {
          if(data.data.code==200){
             this.$toast(data.data.msg);
              this.reload();
          }else{
             this.$toast("已领取");
        }
      })
    },
        jumpUrl(UrlType){
          // 跳转类型 1：链接 2：优惠券 3：商品 4：不跳转
          if(UrlType==1){
            // this.$toast('1链接')
            //  alert(this.ItemDate.pictureAndLinkVOS[0].link)
             let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
              this.url = this.ItemDate.pictureAndLinkVOS[0].link;
              console.log(window.WebViewJavascriptBridge);
              if (isiOS) {
                window.webkit.messageHandlers.jumpList.postMessage(this.url)
              } else {
                this.$bridge.callHandler("jumpList", this.url, res => {
                
                });
              }
              //  window.location.href=this.ItemDate.pictureAndLinkVOS[0].link
          }else if(UrlType==2){
            // 领取优惠券
            // this.$toast('2优惠券')
             let couponId=this.ItemDate.pictureAndLinkVOS[0].couponVOS[0].id
              this.getCouponFun(this.token, couponId)
          }else if(UrlType==3){
            //  this.$toast('3商品')
            //  alert(this.ItemDate.pictureAndLinkVOS[0].productVOS[0].id+'JIA'+this.ItemDate.pictureAndLinkVOS[0].productVOS[0].isRecentExpiration)
            // 3：跳转商品详情  
            this.jumpDetail(this.ItemDate.pictureAndLinkVOS[0].productVOS[0].id,this.ItemDate.pictureAndLinkVOS[0].productVOS[0].isRecentExpiration)
          }
        },
         // 点击跳转详情页   js跳转app
      jumpDetail(id, isRecentExpiration) {
        // alert(id+'我是'+isRecentExpiration)
        let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let detailsData = {
          goods_id: id,
          isRecentExpiration: isRecentExpiration,
        }
        if (isiOS) {
          window.webkit.messageHandlers.jumpGoodsDetail.postMessage(detailsData)
        } else {
          this.$bridge.callHandler("jumpGoodsDetail", detailsData, res => {});
        }
      },


        
    },
     //   注册方法
    mounted() {

    }
  }
</script>
<style lang="scss" scoped>
.ThemeOne {
    width:100%;
    display: block;
    height: auto;
    img{
        display: block;
        width:100%;
        height:auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ActivityTheme/ThemeOne.vue